// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sb-9";
export var arrowButtonContainer = "_sb-5";
export var arrowButtonIcon = "_sb-6";
export var carouselArrowButton = "_sb-2";
export var carouselElementContainer = "_sb-1";
export var currentSlide = "_sb-8";
export var left = "_sb-3";
export var otherSlide = "_sb-a";
export var productCarouselContainer = "_sb-0";
export var right = "_sb-4";
export var sliderOverflow = "_sb-7";